import { SetStateAction, useState } from "react";
import ic_phone_dark_gray from "../assets/icons/ic_phone_dark_gray.svg";
import ic_email_dark_gray from "../assets/icons/ic_email_dark_gray.svg";
import ic_check_circle_green from "../assets/icons/ic_check_circle_green.svg";
import ic_dangerous_circle_red from "../assets/icons/ic_dangerous_circle_red.svg";
import ic_check_circle_white from "../assets/icons/ic_check_circle_white.svg";
import ic_dangerous_circle_white from "../assets/icons/ic_dangerous_circle_white.svg";
import circleInfoSharpRegular from "../assets/icons/circle-info-sharp-regular.svg";
import Title from "../components/atoms/title";
import listText from "../utils/dictionaries/dictionary-account-opening";
import Paragraph from "../components/atoms/paragraph";
import { RadioToggleButton } from "../components/molecules/radio-toggle-buttons";
import Button from "../components/atoms/button";
import { useNavigate } from "react-router-dom";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import TitleAndImage from "../components/molecules/title-and-image";
import OtpUtilService from "../services/otpUtil.service";
import { ValidateCodeUseCase } from "../../application/use-cases/validateCode.usecase";
import { dateISO } from "../utils/helpers";
import BottomSheetMessage from "../components/templates/bottom-sheet-message";
import { useDispatch } from "react-redux";
import { addData } from "../redux/slices/dataReducer";
import { store } from "../redux/store";
import { addNavigate } from "../redux/slices/navigateReducer";
import Input from "../components/molecules/input";
import * as yup from "yup";
import { useFormik } from "formik";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";
import { useFollowLater } from "../hooks/useFollowLater";

const AccountOpening = () => {
  const { onClickContinue } = useFollowLater();
  const state = store.getState();
  const navigate = useNavigate();
  const [radioToggleValue, setRadioToggleValue] = useState(listText.text_4.mainText);
  const [showSpinner, setShowSpinner] = useState(false);
  const [valueClient, setvalueClient] = useState(false);
  const [isOpenBottonSheet, setOpenBottonSheet] = useState(false);
  const otpService = new OtpUtilService();
  const usecaseOtp = new ValidateCodeUseCase(otpService);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);

  const formik = useFormik({
    initialValues: {
      phone: "",
      email: "",
    },
    onSubmit: (values) => console.log(values),
    validationSchema: yup.object({
      phone: yup
        .string()
        .required("Campo requerido")
        .min(10, "Debe contener 10 dígitos")
        .max(10, "Debe contener 10 dígitos"),
      email: yup
        .string()
        .required("Campo requerido")
        .matches(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, "Correo electrónico no válido"),
    }),
  });

  const radioChangeHandler = (e: { target: { value: SetStateAction<string> } }) => {
    setRadioToggleValue(e.target.value);
    if (e.target.value != listText.text_3.mainText) {
      setvalueClient(false);
    } else {
      setvalueClient(true);
    }
  };

  const onSubmit = async (e: any) => {
    setShowSpinner(true);

    dispatch(
      addData({
        processId: state.client.clientPersist.uuid,
        isClient: valueClient,
        phone: formik.values.phone,
        email: formik.values.email,
        emailVerify: false,
        creationDate: dateISO(),
      }),
    );

    const responseOtp = await usecaseOtp.sendOtp(
      {
        phone: formik.values.phone,
        email: formik.values.email,
        channel: "EMAIL",
        date: dateISO(),
      },
      state.client.clientPersist.uuid,
    );

    if (responseOtp.error != null) {
      setModalShow(true)
    } else {
      dispatch(
        addNavigate({
          progressBarPercentage: "15%",
          editableValue: formik.values.email,
          typeValue: "mail",
          textButton: "Continuar",
          nextContinue: "/IneConsent",
          comeFrom: "AccountOpening",
        }),
      );
      onClickContinue({
        data: formik.values,
        processId: state.client.clientPersist.uuid,
        resource: "AccountOpening",
        step: "CONTINUE",
      });
      navigate("/ValidateCode");
    }
    setShowSpinner(false);
  };

  const functionProcessModal = () => {
    setModalShow(false);
  };

  const followLaterAction = () => {
    navigate("/FollowLater", {
      state: {
        processId: state.client.clientPersist.uuid,
        resource: "AccountOpening",
        step: "CONTINUE_AFTER",
        data: formik.values, // Agregar data del formulario
      },
    });
  };

  return (
    <>
      <div className="content-container">
        <Top
          titleHeader={"Apertura de cuenta"}
          subTitle={listText.text_1.mainText}
          displayProgressBar={""}
          displayLeftImageTitle={""}
          classTitleImage={"ms-2"}
          classHeader={"mt-2"}
          styleHeader={{}}
          classProgressBar={"mt-3"}
          styleProgressBar={{}}
          classTitleAndImage={""}
          styleTitleAndImage={{}}
          valueProgressBar={"10%"}
          comeFrom={"/AccountOpening"}
          onClickGoBackIcon={() => navigate("/InformationRequeriments")}
        />
        <div className="p-3">
          <Paragraph
            text={listText.text_2.mainText}
            className={"fs-6 mb-0 lh-base"}
            styleParagraph={undefined}
          />
          <div className="mb-3">
            <RadioToggleButton
              id={listText.text_3.mainText}
              text={listText.text_3.mainText}
              value={listText.text_3.mainText}
              type={"radio"}
              name={listText.text_3.mainText}
              onChange={radioChangeHandler}
              isSelected={radioToggleValue == listText.text_3.mainText}
              className="radioToggleButton me-3"
              icon={
                radioToggleValue == listText.text_3.mainText
                  ? ic_check_circle_white
                  : ic_check_circle_green
              }
              displayImg="d-none"
              disabledInput={undefined}
              divStyle={undefined}
              labelStyle={undefined}
              onClick={undefined}
            />
            <RadioToggleButton
              id={listText.text_4.mainText}
              text={listText.text_4.mainText}
              value={listText.text_4.mainText}
              type={"radio"}
              name={listText.text_4.mainText}
              onChange={radioChangeHandler}
              isSelected={radioToggleValue == listText.text_4.mainText}
              className="radioToggleButton"
              icon={
                radioToggleValue == listText.text_4.mainText
                  ? ic_dangerous_circle_white
                  : ic_dangerous_circle_red
              }
              displayImg="d-none"
              disabledInput={undefined}
              divStyle={undefined}
              labelStyle={undefined}
              onClick={undefined}
            />
          </div>
          <TitleAndImage
            srcImage={circleInfoSharpRegular}
            titleText={listText.text_18.mainText}
            displayLeftImageTitle={""}
            classTitle={"m-2"}
            styleTitle={{
              color: "#005CB9",
              fontSize: "16px",
              cursor: "pointer",
            }}
            onClickTitleImgeDiv={() => setOpenBottonSheet(true)}
            divClass={"mt-3 mb-3"}
          />
          <hr />
          <div className="my-3">
            <Title
              text={listText.text_5.mainText}
              className={"fs-6 fw-bold"}
              styleTitle={undefined}
            />
          </div>
          <div className="mb-4">
            <Input
              className={`form-control ${formik.errors.phone ? "is-invalid" : ""}`}
              type="number"
              id="phone"
              name="phone"
              placeholder=""
              value={formik.values.phone || ""}
              error={formik.errors.phone ? formik.errors.phone : ""}
              text={listText.text_7.mainText}
              onChange={(e: any) => formik.setFieldValue("phone", e.target.value)}
              onBlur={formik.handleBlur}
              src={ic_phone_dark_gray}
              disabled={false}
              style={undefined}
              displayLabel=""
              htmlFor="phone"
            ></Input>
          </div>
          <div className="mb-4">
            <Input
              className={`form-control ${formik.errors.email ? "is-invalid" : ""}`}
              type="email"
              id="email"
              name="email"
              placeholder=""
              value={formik.values.email || ""}
              error={formik.errors.email ? formik.errors.email : ""}
              text={listText.text_8.mainText}
              onChange={(e: any) => formik.setFieldValue("email", e.target.value)}
              onBlur={formik.handleBlur}
              src={ic_email_dark_gray}
              disabled={false}
              style={undefined}
              displayLabel=""
              htmlFor="email"
            ></Input>
          </div>
          <div className="mb-4_3">
            <Paragraph
              text={listText.text_9.mainText}
              className={"fs-6 dark-gray-paragraph lh-base"}
              styleParagraph={undefined}
            />
          </div>
        </div>
      </div>
      <div className="footer--pin">
        <Button
          text={listText.text_10.mainText}
          divClassName={"d-grid gap-2"}
          buttonClassName={`${showSpinner ? "pe-none" : ""
            } btn-bg-primary text-white w-100 place-content-center align-self-center`}
          spinner={showSpinner}
          onClick={(d: any) => onSubmit(d)}
          disabled={
            formik.errors.phone ||
            formik.values.phone == "" ||
            formik.errors.email ||
            formik.values.email == ""
          }
        />
        <div className="text-center mt-3">
          <Link
            text={"Seguir más tarde"}
            url={null}
            styleLink={{
              color: "#5A6172",
              lineHeight: "16px",
              textDecoration: "none",
              cursor: "pointer",
            }}
            onClick={() => followLaterAction()}
            className={""}
          />
        </div>
      </div>
      <BottomSheetMessage
        imageInside={undefined}
        title={listText.text_18.mainText}
        text={listText.text_19.mainText}
        isOpen={isOpenBottonSheet}
        onClickClose={() => setOpenBottonSheet(false)}
        styleMainDiv={{ height: "auto" }}
      />
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle="¡Ups lo sentimos!"
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: "Reintentar",
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => {
              functionProcessModal();
            },
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: "La aplicación no esta respondiendo debido a que hay problemas con la comunicación de nuestros sistemas.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: "Vuelve a intentar si el error persiste.",
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default AccountOpening;
